import { ReactNode } from "react";
import styles from "./boxedSelector.module.scss";

interface IProps {
  className?: string;
  children: ReactNode;
  dropdownOpenFromRight? :boolean;
  newStyles?: boolean;
  formView: "horizontalView" | "verticalView";
  isHorizontalVehicleSelector?: boolean;
}
const BoxedSelector = (props: IProps) => {
  const {
    children, className, dropdownOpenFromRight = false, newStyles = true, formView = "horizontalView",
    isHorizontalVehicleSelector,
  } = props;

  // const { selectedId } = useSelector((state: RootState) => state.modal);
  // const [dropdownOpenFromRight, setDropdownOpenFromRight] = useState<boolean>(false);

  // const ref = useRef(null);

  // dynamic placing of vehicle selector form
  // useEffect(() => {
  //   if (ref.current) {
  //     const ignoreDropdownPositioning = selectedId === "vehicleSelector"; // We can remove it after more testing
  //     const openFromRight = !ignoreDropdownPositioning ? !distanceBetweenElements(document.getElementById("page-container"),
  //       ref.current, "right", 330) : false;
  //     setDropdownOpenFromRight(openFromRight);
  //   }
  // }, [ref.current]);

  return (
    <div
      className={`
        ${formView === "horizontalView" ? styles.boxed_selector : ""} 
        ${className} ${newStyles ? styles.new_box_selector_styles : ""}
         ${dropdownOpenFromRight ? styles.open_from_right : ""}
         ${isHorizontalVehicleSelector ? styles.horizontal_vehicle_selector : styles.vertical_vehicle_selector}`}
      // ref={ref}
    >
      {children}
    </div>
  );
};

export default BoxedSelector;
